import * as React from 'react';
import * as styled from './styled';
import {getImageByPreview} from 'api/library';
import Tag from 'components/Tag';
import {AuthorCard} from 'components/AuthorCard';
import {HeaderProps} from './types';

/**
 * The header of a viewer.
 * @param {HeaderProps} props
 * @return {React.ReactElement<HeaderProps>}
 * @constructor
 */
export default function Header(
    props: HeaderProps,
): React.ReactElement<HeaderProps> {
  /**
   * Render thumbnail.
   * @return {JSX.Element | undefined}
   */
  function renderThumbnail(): JSX.Element | undefined {
    return props.preview !== null ? (
      <styled.Thumbnail
        src={getImageByPreview(props.preview)}
      />
    ) : undefined;
  }

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render tags.
     * @return {JSX.Element}
     */
    function renderTags(): JSX.Element {
      return (
        <styled.Tags>
          {props.tags?.map((tag, index) => (
            <Tag key={index}>
              {tag}
            </Tag>
          ))}
        </styled.Tags>
      );
    }
    /**
     * Render title.
     * @return {JSX.Element}
     */
    function renderTitle(): JSX.Element {
      return (
        <styled.Title>
          {props.title}
        </styled.Title>
      );
    }

    /**
     * Render description.
     * @return {JSX.Element}
     */
    function renderDescription(): JSX.Element {
      return (
        <styled.Description>
          {props.description}
        </styled.Description>
      );
    }

    /**
     * Render author.
     * @return {JSX.Element | undefined}
     */
    function renderAuthor(): JSX.Element | undefined{
      return props.authorId ? (
        <styled.Sidebar>
          <AuthorCard
            userId={props.authorId}
          />
        </styled.Sidebar>
      ) : undefined;
    }

    return (
      <styled.Content>
        {renderTags()}
        {renderTitle()}
        {renderDescription()}
        {renderAuthor()}
      </styled.Content>
    );
  }

  return (
    <styled.Wrapper>
      {renderThumbnail()}
      {renderContent()}
    </styled.Wrapper>
  );
}
